<div id="form-container">
  <form
    [formGroup]="strategicPillarForm"
    id="strategic-pillar-form"
    class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8"
    (ngSubmit)="onSubmit()"
    >
    <h3 class="ui-heading-3-bold">
      {{ selectedStrategicPillar?.id === 0 ? 'Add Strategic Pillar' : 'Edit Strategic Pillar' }}
    </h3>
    <div id="editable">
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Title <span class="c-error">*</span></rds-control-label>
        <input rdsInput formControlName="title" placeholder="e.g., MTO1" />
      </rds-form-field>

      <rds-form-field labelPosition="side-left">
        <rds-control-label>Description <span class="c-error">*</span></rds-control-label>
        <textarea rdsInput formControlName="description" placeholder="Description of the strategic pillar" rows="3"></textarea>
      </rds-form-field>

      <div class="rds-form-field">
        <rds-control-label>Color <span class="c-error">*</span></rds-control-label>
        <div class="color-picker-grid">
          @for (color of colorOptions; track color) {
            <button
              type="button"
              class="color-option"
              [class.selected]="strategicPillarForm.get('color_code')?.value === color"
              [style.background-color]="color"
              (click)="selectColor(color)"
              >
            </button>
          }
        </div>
      </div>
    </div>

    <div id="controls" rds-drawer-actions class="button-controls">
      @if (selectedStrategicPillar?.id !== 0) {
        <button
          rds-secondary-warning-button
          type="button"
          (click)="onDelete()"
          class="delete-button"
          >
          Delete
        </button>
      }
      <button
        rds-primary-button
        type="submit"
        class="update-button"
        [disabled]="isLoadingChanges"
        >
        @if (!isLoadingChanges) {
          {{ selectedStrategicPillar?.id === 0 ? 'Add' : 'Update' }}
        } @else {
          <rds-progress-spinner label="Saving..." size="m" white></rds-progress-spinner>
        }
      </button>
    </div>
  </form>
</div>